//== DEFAULTS RAILS
  import Rails from "@rails/ujs"
  Rails.start()

//== BOOTSTRAP
  import { Popper } from '@popperjs/core'
  import { Collapse } from 'bootstrap'
